// src/config/pickupPoints.js — Пункты самовывоза

export const PICKUP_POINTS = [
  { id: '1', address: 'ул. Ю.Гагарина, д. 16Б', hours: '10:00–21:50', affiliate: '184' },
  { id: '2', address: 'ул. Согласия, д. 46', hours: '10:00–21:50', affiliate: '435' },
  { id: '3', address: 'ул. Автомобильная, д. 12Б', hours: '10:00–21:50', affiliate: '457' },
  { id: '4', address: 'Гурьевск', hours: '10:00–21:50', affiliate: '396' },
];
